import { useState } from 'react';
import { Button } from '@produzionejb/ui';
import { downloadFile, ApiError } from '../lib/api-client';

interface XlsxExportButtonProps {
  path: string;
  fallbackFilename: string;
  label?: string;
  size?: 'sm' | 'md' | 'lg';
  variant?: 'primary' | 'secondary' | 'danger' | 'ghost';
  disabled?: boolean;
}

export function XlsxExportButton({
  path,
  fallbackFilename,
  label = 'Esporta Excel',
  size = 'sm',
  variant = 'secondary',
  disabled,
}: XlsxExportButtonProps) {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  async function handleClick() {
    setLoading(true);
    setError(null);
    try {
      await downloadFile(path, fallbackFilename);
    } catch (e) {
      const msg = e instanceof ApiError ? e.message : 'Errore download Excel';
      setError(msg);
      setTimeout(() => setError(null), 4000);
    } finally {
      setLoading(false);
    }
  }

  return (
    <div className="flex items-center gap-2">
      <Button
        type="button"
        size={size}
        variant={variant}
        onClick={handleClick}
        disabled={disabled || loading}
        title="Scarica i risultati attuali in formato Excel (.xlsx)"
      >
        {loading ? 'Genero...' : label}
      </Button>
      {error && <span className="text-xs text-red-600">{error}</span>}
    </div>
  );
}
